"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelType = void 0;
var ModelType;
(function (ModelType) {
    ModelType["ANALYSIS"] = "Analysis";
    ModelType["ARTICLE"] = "Article";
    ModelType["DECISION"] = "Decision";
    ModelType["GLOSSARY_TERM"] = "GlossaryTerm";
    ModelType["LAW_TEXT"] = "LawText";
    ModelType["PUBLICATION_SHEET"] = "PublicationSheet";
    ModelType["STATISTIC"] = "Statistic";
})(ModelType || (exports.ModelType = ModelType = {}));
//# sourceMappingURL=modelType.js.map